import { useCallback, useEffect, useMemo, useState } from "react";

import { useSearchModelConverter } from "./converter";

import type * as Model from "./type";

export const useSearchModel = () => {
	const { onConvertSearchModel } = useSearchModelConverter();
	/**
	 * state の初期値
	 */
	const initSearchModel = useMemo(() => onConvertSearchModel(), [onConvertSearchModel]);
	const [searchModel, setSearchModel] = useState<Model.SearchModel>(initSearchModel);
	useEffect(() => {
		setSearchModel(initSearchModel);
	}, [initSearchModel]);

	/**
	 * 詳細検索のメルマガ配信希望者フラグの変更
	 */
	const onChangeIsAcceptMailMagazineChecked = useCallback((value: boolean) => {
		setSearchModel((prev) => ({ ...prev, isAcceptMailMagazineChecked: value }));
	}, []);
	/**
	 * 詳細検索の現地決済者フラグの変更
	 */
	const onChangeIsLocalPaymentChecked = useCallback((value: boolean) => {
		setSearchModel((prev) => ({ ...prev, isLocalPaymentChecked: value }));
	}, []);

	return {
		//
		searchModel,
		//
		// 詳細検索のメルマガ配信希望者フラグの変更
		onChangeIsAcceptMailMagazineChecked,
		// 詳細検索の現地決済者フラグの変更
		onChangeIsLocalPaymentChecked,
	};
};
